import { render } from "./Invoice.vue?vue&type=template&id=6e2065c5&scoped=true"
import script from "../js/invoice.js?vue&type=script&lang=js&external"
export * from "../js/invoice.js?vue&type=script&lang=js&external"

import "./Invoice.vue?vue&type=style&index=0&id=6e2065c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2065c5"]])

export default __exports__